/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-console */
import { isPresent } from '@mbfab/shared'
import dayjs from 'dayjs'
import posthog from 'posthog-js'

import { envVariables } from '../lib/env'

import { logger } from './logger'
import type { PosthogEvent } from './posthog/posthog_events'

const POSTHOG_API_KEY = envVariables.POSTHOG_API_KEY
const POSTHOG_API_URL = envVariables.POSTHOG_API_URL
const isEnabled = isPresent(POSTHOG_API_KEY) && isPresent(POSTHOG_API_URL) && typeof window !== 'undefined'
if (isEnabled) {
  posthog.init(POSTHOG_API_KEY, { api_host: POSTHOG_API_URL })
}

const track = (eventName: PosthogEvent, props = {}) => {
  try {
    if (isEnabled && (props as any).role !== 'admin') {
      posthog.capture(eventName, props)
    } else {
      void logger.debug(`[POSTHOG] ${eventName}`, props)
    }
  } catch (e) {
    console.warn(e)
  }
}

function getKey(identityId: string, key: string) {
  return `posthog-cloud/${identityId}/${key}`
}

const getPosthogCache = (identityId: string, key: string) => {
  return localStorage.getItem(getKey(identityId, key))
}

const setPosthogCache = (identityId: string, key: string, data: string) => {
  localStorage.setItem(getKey(identityId, key), data)
}

export const Posthog = {
  identifyOnce(identityId: string, properties: Array<Record<string, unknown>>) {
    const cache = getPosthogCache(identityId, 'identifyOnce')
    const newData = JSON.stringify(properties)
    if (cache !== newData) {
      if (isEnabled) {
        posthog.identify(identityId, ...(properties ?? []))
      }
      setPosthogCache(identityId, 'identifyOnce', newData)
    }
  },
  setPeopleOnce(identityId: string, properties: Array<Record<string, unknown>>) {
    const cache = getPosthogCache(identityId, 'setPeopleOnce')
    const newData = JSON.stringify(properties)
    if (cache !== newData) {
      for (const property of properties) {
        if (isEnabled) {
          // set_onceもあるが、このonceは「propertyがまだなかったら」の意味であり、後からpropertyに渡したい値が変わった時に対応できなくなるため使わない
          posthog.people.set(property)
        }
      }
      setPosthogCache(identityId, 'setPeopleOnce', newData)
    }
  },
  trackAccess(pathname: string, property: Record<string, unknown>) {
    track('visit', {
      ...property,
      pathname,
      timestampJa: dayjs().format('YYYY年M月D日 H時m分s秒'),
    })
  },
  trackOnce(value: PosthogEvent, props = {}) {
    track(value, props)
  },
  track,
}
